import { FileText, Download, CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from '../ui/button';

const REQUIRED_COLS = ['category_name', 'name'];
const OPTIONAL_COLS = [
  'description', 'sku', 'wholesale_price', 'stock_status',
  'carton_size', 'unit_size', 'weight', 'dimensions',
  'brand', 'barcode', 'country_of_origin', 'ingredients', 'is_featured',
];

export function BulkImportInfo({ onDownloadTemplate }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm">
      <div className="font-semibold text-slate-800 mb-2 flex items-center gap-2">
        <FileText className="w-4 h-4" /> CSV format
      </div>
      <p className="text-slate-600 mb-2">
        Required columns: <code className="bg-white px-1.5 py-0.5 rounded border">{REQUIRED_COLS.join(', ')}</code>
      </p>
      <p className="text-slate-600 mb-3 text-xs">
        Optional: {OPTIONAL_COLS.join(', ')}
      </p>
      <p className="text-xs text-slate-500 mb-3">
        stock_status must be one of: in_stock, low_stock, out_of_stock. is_featured accepts: true/false, yes/no, 1/0.
      </p>
      <Button
        data-testid="download-template-button"
        variant="outline"
        size="sm"
        onClick={onDownloadTemplate}
      >
        <Download className="w-4 h-4 mr-2" />Download template CSV
      </Button>
    </div>
  );
}

export function BulkImportResult({ result }) {
  if (!result) return null;
  return (
    <div data-testid="bulk-import-result" className="space-y-2">
      <div className="flex items-center gap-2 rounded-lg bg-green-50 border border-green-200 p-3 text-sm text-green-800">
        <CheckCircle className="w-5 h-5" />
        <span><b>{result.created}</b> product{result.created === 1 ? '' : 's'} created</span>
      </div>
      {result.error_count > 0 && <ErrorList errors={result.errors} count={result.error_count} />}
    </div>
  );
}

function ErrorList({ errors, count }) {
  return (
    <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
      <div className="flex items-center gap-2 text-sm text-amber-800 font-medium mb-1.5">
        <AlertCircle className="w-5 h-5" />
        {count} row{count === 1 ? '' : 's'} skipped
      </div>
      <ul className="text-xs text-amber-800 space-y-0.5 max-h-40 overflow-y-auto pl-6 list-disc">
        {errors.map((err, i) => (
          <li key={i}>Row {err.row}: {err.error}</li>
        ))}
      </ul>
    </div>
  );
}
